const Visitors = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/Visitors")
const CommissionRanges = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/commissionRanges")
const Paths = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/Paths")
const Drivers = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/Drivers")
const Distributors = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/Distributors")
const Cars = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/Cars")
const DistributionForm = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/DistributionForm")
const DistributionRemittance = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/DistributionRemittance")

const DistributionsList = () => import( /* wepackChunkName: "distribution" */ "@/modules/distribution/DistributionsList")

export default [{
    name: 'Visitors',
    path: 'visitors/:level',
    component: Visitors,
    props: true,
  },
  {
    name: 'CommissionRanges',
    path: 'commissionRanges',
    component: CommissionRanges,
  },
  {
    name: 'Paths',
    path: 'paths/:level',
    component: Paths,
    props: true,
  }, {
    name: 'Drivers',
    path: 'drivers',
    component: Drivers,
  }, {
    name: 'Distributors',
    path: 'distributors',
    component: Distributors
  }, {
    name: 'Cars',
    path: 'cars',
    component: Cars,
  }, {
    name: 'DistributionForm',
    path: 'distribution/:id?',
    component: DistributionForm,
    props: true
  },
  {
    name: 'DistributionRemittance',
    path: 'distributionRemittance/:id',
    component: DistributionRemittance,
    props: true
  }, {
    name: 'DistributionsList',
    path: 'lists/distributions',
    component: DistributionsList,
  },

]